module.exports = __webpack_public_path__ + "img/no.4cd67d98.png";